import React from 'react';

import { Column } from '@prisjakt/ui/list/variants';

import { HighlightedName } from '../highlighted-name';
import { ExtendSearchButton } from '../extend-search-button';

import {
  ListItem,
  ListItemButton,
  NameLabel,
  Labels,
  Wrapper,
  SearchIcon,
} from './styles';

import { BaseItemProps } from './types';

type Props = Omit<BaseItemProps, 'id'>;

export const KeywordItem = (props: Props) => {
  const { text, order, selected, onClick, onExtendSearch, query } = props;

  return (
    <ListItem data-test="KeywordItem" order={order} $selected={selected}>
      <ListItemButton onClick={onClick}>
        <Wrapper>
          <SearchIcon size={16} />

          <Labels>
            <Column>
              <NameLabel>
                <HighlightedName query={query}>{text}</HighlightedName>
              </NameLabel>
            </Column>
          </Labels>
        </Wrapper>
      </ListItemButton>
      {onExtendSearch && <ExtendSearchButton onClick={onExtendSearch} />}
    </ListItem>
  );
};
